module.exports = __webpack_public_path__ + "static/media/close.cf59cd2b.svg";